import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, removeDuplicatesFromArray, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as urls from '../oldReportsUrls'
import moment from 'moment/moment'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { reportOptionSum, reportOptionDet, reportViewData } from './constants'
import LRDetails from './LRDetails'
import { GetRequest } from '../../../common/api'
import { urls as urls2 } from '../../../common/constants'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import SummaryReport from './summaryReport'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
const AnalysisReport = (props) => {
  const reportName = 'Analysis'
  const { data } = props
  const { common } = data
  const { loginData, loader,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel, AllowViewAllBranchOfCityReport } = { ...roleRightsData }
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceCityData, setSourceCityData] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchData, setDestinationBranchData] = useState([])
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const [reportOptions, setReportOptions] = useState(reportOptionDet)
  const [reportOptionsData, setReportOptionsData] = useState(reportOptionDet)
  const [showTable, setShowTable] = useState(false)
  const [showTableData, setShowTableData] = useState({})
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [, setAlert] = useAtom(alertAtom)
  const headerDataPDF = {
    toDate: toDate.format('DD-MMM-YYYY'),
    fromDate: fromDate.format('DD-MMM-YYYY'),
    selSourceCity: selSourceCity?.SourceCity,
    selSourceBranch: selSourceBranch?.SourceBranch,
    selDestinationCity: selDestinationCity?.DestinationCity,
    selDestinationBranch: selDestinationBranch?.DestinationBranch,
    paymentType: paymentType?.name,
    reportView: reportView?.view,
    reportOptions: reportOptions?.[0]?.optionId === 0 ? reportOptions[0].Option : 'Multi Selected',
    dataType:'entry'
  }
  useEffect(() => {
    focusElemnt(id.anlsFromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(cargoRoleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(AllowViewAllBranchReport || AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin)
      )
      setDisableExcel(!AllowExportExcel)
    }
  }, [cargoRoleRights, loginData])

  const handleClick2 = () => {
    let url = urls.analysisReport
    const urlData = urls.analysisReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDate = fromDate.format('DD-MMM-YYYY')
    urlData.ToDate = toDate.format('DD-MMM-YYYY')
    urlData.LoginCompanyId = loginData.intCompanyID
    urlData.LoginBranchId = loginData.intBranchID
    urlData.FromCityId = selSourceCity.BookingCityID
    urlData.FromBranchId = selSourceBranch.BookingBranchID
    urlData.ToCityId = selDestinationCity.DestinationCityID
    urlData.ToBranchId = selDestinationBranch.DestinationBranchID
    urlData.PaymentMode = paymentType.typeId
    urlData.LoginUserId = loginData.intUserID
    urlData.FromCityName = selSourceCity.SourceCity
    urlData.FromBranchName = selSourceBranch.SourceBranch
    urlData.DestCityName = selDestinationCity.DestinationCity
    urlData.DestBranchName = selDestinationBranch.DestinationBranch
    urlData.PaymentType = paymentType.name
    urlData.IsSummary = 0
    urlData.IsPaymentwise = reportOptions.find((item) => item?.optionId === 1) ? 1 : 0
    urlData.IsBookingCity = reportOptions.find((item) => item?.optionId === 2) ? 1 : 0
    urlData.IsBookingBranch = reportOptions.find((item) => item?.optionId === 3) ? 1 : 0
    urlData.IsDestBranch = reportOptions.find((item) => item?.optionId === 4) ? 1 : 0
    urlData.IsDestCity = reportOptions.find((item) => item?.optionId === 5) ? 1 : 0
    urlData.IsExtendedReport = reportView?.id == 1 ? 0 : 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const callFilterAPi = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
      }
      GetRequest(urls2.getAnalysisDropData, obj).then((res) => {
        if (res.status == 'Success') {
          if (res?.Data?.Table?.length > 0) {
            let data = []
            let data1 = []
            let data2 = []
            let data3 = []
            res.Data.Table?.map((val, i) => {
              data.push({ SourceCity: val?.SourceCity, BookingCityID: val?.BookingCityID })
              data1.push({ SourceBranch: val?.SourceBranch, BookingBranchID: val?.BookingBranchID, SourceCity: val?.SourceCity })
              data2.push({
                DestinationCity: val?.DestinationCity,
                DestinationCityID: val?.DestinationCityID,
                SourceCity: val.SourceCity,
              })
              data3.push({
                DestinationBranch: val?.DestinationBranch,
                DestinationBranchID: val?.DestinationBranchID,
                DestinationCity: val?.DestinationCity,
              })
            })
            setSourceCityData([{ SourceCity: 'All Cities', BookingCityID: 0 }, ...data])
            setSourceBranchData([{ SourceBranch: 'All Branches', BookingBranchID: 0 }, ...data1])
            setDestinationCityData([{ DestinationCity: 'All Cities', DestinationCityID: 0 }, ...data2])
            setDestinationBranchData([{ DestinationBranch: 'All Branch', DestinationBranchID: 0 }, ...data3])
            if (disableBtn) {
              setSelSourceCity({ SourceCity: loginData?.strCityName, BookingCityID: loginData?.intBranchCityID })
              setSelSourceBranch({ SourceBranch: loginData?.strBranchName, BookingBranchID: loginData?.intBranchID })
            } else {
              setSelSourceCity({ SourceCity: 'All Cities', BookingCityID: 0 })
              setSelSourceBranch({ SourceBranch: 'All Branches', BookingBranchID: 0 })
            }
            setSelDestinationCity({ DestinationCity: 'All Cities', DestinationCityID: 0 })
            setSelDestinationBranch({ DestinationBranch: 'All Branch', DestinationBranchID: 0 })
          } else {
            setSourceCityData([])
            setSourceBranchData([])
            setDestinationCityData([])
            setDestinationBranchData([])
            setSelSourceCity(' ')
            setSelSourceBranch(' ')
            setSelDestinationCity('  ')
            setSelDestinationBranch(' ')
          }
        } else {
          setAlert({ show: true, msg: 'No Data', nextId: '' })
        }
      })
    }
  }
  const handleClick1 = () => {
    if (selSourceCity == '' || selSourceCity == ' ') {
      setAlert({ show: true, msg: 'Select Source City', nextId: '' })
    }
    if (selSourceBranch == '' || selSourceBranch == ' ') {
      setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const body = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intFromCityID: selSourceCity?.BookingCityID,
        intFromBranchID: selSourceBranch?.BookingBranchID,
        intToCityID: selDestinationCity?.DestinationCityID,
        intToBranchID: selDestinationBranch?.DestinationBranchID,
        PayTypeIDs: paymentType?.typeId,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
        intUserID: loginData?.intUserID,
      }
      GetRequest(urls2.getAnalysisTableData, body).then((res) => {
        if (res.status == 'Success') {
          const updatedData = { ...res.Data };
          if (UseToPayAsCOD === 1) {
            if (Array.isArray(updatedData.Table1)) {
              updatedData.Table1 = updatedData.Table1.map(item =>
                item.PaymentType === 'TO-PAY'
                  ? { ...item, PaymentType: 'COD' }
                  : item
              );
            }
            if (Array.isArray(updatedData.Table6)) {
              updatedData.Table6 = updatedData.Table6.map(item =>
                item.PaymentType === 'TO-PAY'
                  ? { ...item, PaymentType: 'COD' }
                  : item
              );
            }
          }
          setShowTableData(updatedData);
          setShowTable(true)
        } else {
          setAlert({ show: true, msg: 'No Data', nextId: '' })
        }
      })
    }
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelSourceCity('')
    setSelSourceBranch('')
    setSelDestinationCity('')
    setSelDestinationBranch('')
    setPaymentType(paymentModesWithAll?.[0])
    setReportView(reportViewData?.[1])
    setReportOptions(reportOptionDet)
    setReportOptionsData(reportOptionDet)
    setShowTable(false)
  }

  const selectedReportView = (value) => {
    setReportView(value)
    setShowTable(false)
    if (value?.id === 1) {
      setReportOptionsData(reportOptionSum)
      setReportOptions([reportOptionSum?.[0]])
    } else {
      setReportOptionsData(reportOptionDet)
      setReportOptions([reportOptionDet?.[0]])
    }
  }
  const tableShow = () => {
    let Table
    if (reportView?.id === 1) {
      Table = <SummaryReport  headerData={headerDataPDF} tableData={showTableData} reportOptions={reportOptions} />
    } else {
      Table = <LRDetails headerData={headerDataPDF} tableData={showTableData?.Table} />
    }
    return Table
  }

  const selectedSourceCity = (obj) => {
    setSelSourceCity(obj)
    setShowTable(false)
    setSelSourceBranch(
      removeDuplicatesFromArray(sourceBranchData, 'BookingBranchID').filter(
        (val) => val.SourceCity === obj?.SourceCity || obj?.BookingCityID === 0 || val.BookingBranchID === 0
      )?.[0]
    )
  }
  const selectedDestCity = (obj) => {
    setSelDestinationCity(obj)
    setShowTable(false)
    setSelDestinationBranch(
      removeDuplicatesFromArray(destinationBranchData, 'DestinationBranchID').filter(
        (val) => val.DestinationCity === obj?.DestinationCity || obj?.DestinationCityID === 0 || val.DestinationBranchID === 0
      )?.[0]
    )
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              disabled={true}
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={id.goButton}
              className="btn btn-primary"
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '50px' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Booking Date'}
              id={id.anlsFromDate}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt(id.anlsToDate)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '50px' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              value={toDate}
              id={id.anlsToDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt(id.anlsGoButton)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={callFilterAPi}
              id={id.anlsGoButton}
              onKeyDown={(e) => navigation3(e, id.anSourceCity, id.anlsToDate, callFilterAPi)}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} style={{ width: '180px' }}>
            <DropDownOA
              id={id.anSourceCity}
              label={'Source City'}
              searchPlaceholder={`Search Source City`}
              defaultvalue={selSourceCity?.SourceCity || selSourceCity}
              data={removeDuplicatesFromArray(sourceCityData, 'BookingCityID') || []}
              listWidth="200px"
              dataKey={`SourceCity`}
              idKey={`BookingCityID`}
              disabled={disableBtn}
              onSelect={(obj) => selectedSourceCity(obj)}
              nextId={id.anSourceBranch}
              prevId={id.anlsGoButton}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '180px' }}>
            <DropDownOA
              id={id.anSourceBranch}
              label={'Source Branch'}
              searchPlaceholder={`Search Source Branch`}
              defaultvalue={selSourceBranch?.SourceBranch || selSourceBranch}
              data={
                removeDuplicatesFromArray(sourceBranchData, 'BookingBranchID').filter(
                  (val) => val.SourceCity === selSourceCity?.SourceCity || selSourceCity?.BookingCityID === 0 || val.BookingBranchID === 0
                ) || []
              }
              listWidth="200px"
              dataKey={`SourceBranch`}
              idKey={`BookingBranchID`}
              disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
              onSelect={(obj) => {
                setSelSourceBranch(obj)
                setShowTable(false)
              }}
              nextId={id.anDestinationCity}
              prevId={id.anSourceCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '180px' }}>
            <DropDownOA
              id={id.anDestinationCity}
              label={'Destination City'}
              searchPlaceholder={`Search Destination City`}
              defaultvalue={selDestinationCity?.DestinationCity || selDestinationCity}
              data={
                removeDuplicatesFromArray(destinationCityData, 'DestinationCityID').filter(
                  (val) => val.DestinationCity !== selSourceCity?.SourceCity || val.DestinationCityID === 0
                ) || []
              }
              listWidth="200px"
              dataKey={`DestinationCity`}
              idKey={`DestinationCityID`}
              onSelect={(obj) => selectedDestCity(obj)}
              nextId={id.anDestinationBranch}
              prevId={id.anSourceBranch}
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex }}>
          <Item sx={sx.itemsx} style={{ width: '205px' }}>
            <DropDownOA
              id={id.anDestinationBranch}
              defaultvalue={selDestinationBranch?.DestinationBranch || selDestinationBranch}
              data={
                removeDuplicatesFromArray(destinationBranchData, 'DestinationBranchID').filter(
                  (val) =>
                    val.DestinationCity === selDestinationCity?.DestinationCity ||
                    selDestinationCity?.DestinationCityID === 0 ||
                    val.DestinationBranchID === 0
                ) || []
              }
              width="100%"
              searchPlaceholder={`Search Destination Branch`}
              label={'Destination Branch'}
              tabIndex="2"
              dataKey={`DestinationBranch`}
              idKey={`DestinationBranchID`}
              onSelect={(value) => {
                setSelDestinationBranch(value)
                setShowTable(false)
              }}
              nextId={id.anPaymentType}
              prevId={id.anDestinationCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '205px' }}>
            <DropDownOA
              id={id.anPaymentType}
              // data={paymentModesWithAll || []}
              data={
                (paymentModesWithAll || []).map((item) => {
                  if (UseToPayAsCOD === 1) {
                    if (item.typeId === 2) {
                      return { ...item, name: 'COD' };
                    }
                    if (item.typeId === 7) {
                      return { ...item, name: 'COD Manual' };
                    }
                    if (item.typeId === 9) {
                      return { ...item, name: 'COD DDDV' };
                    }
                    if (item.typeId === 4) {
                      return null;
                    }
                  }
                  return item;
                }).filter(Boolean)
              }
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => {
                setPaymentType(value)
                setShowTable(false)
              }}
              nextId={id.anView}
              prevId={id.anDestinationBranch}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '177px' }}>
            <DropDownOA
              id={id.anView}
              defaultvalue={reportView?.view}
              data={reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => selectedReportView(value)}
              nextId={id.anReportOptions}
              prevId={id.anPaymentType}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownMultiSelectV2
              id={id.anReportOptions}
              data={reportOptionsData || []}
              defaultvalue={reportOptions}
              width="100%"
              HasAllSelect={true}
              searchPlaceholder={`Search By Report Options`}
              label={'Report Options'}
              tabIndex="2"
              dataKey={`Option`}
              idKey={`optionId`}
              listWidth="200px"
              limit={reportView?.id ? 200 : 1}
              onSelect={(value) => {
                setReportOptions(value)
                setShowTable(false)
              }}
              nextId={id.anSplitButton}
              prevId={id.anView}
            />
          </Item>

          <Item
            sx={sx.itemsx}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) =>
              navigation3(
                e,
                showTable ? (disableExcel ? 'anaxportAsPdfBtn' : 'analsExpToExlbtn') : id.anlsFromDate,
                id.anReportOptions,
                () => handleClick1()
              )
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              id1={id.anSplitButton}
              prevID={id.anReportOptions}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg width={'24px'} height={'24px'} />
          </Item>
        </Box>
      </Item>
      <Item>{showTable && tableShow()}</Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
export default connect(mapStateToProps)(AnalysisReport)
